import React from "react";

export function Tooltip({content,side="top",children,style,...rest}){
  const [open,setOpen]=React.useState(false);
  const pos=side==="bottom"?{top:"calc(100% + 6px)",left:"50%",transform:"translateX(-50%)"}
    :side==="left"?{right:"calc(100% + 6px)",top:"50%",transform:"translateY(-50%)"}
    :side==="right"?{left:"calc(100% + 6px)",top:"50%",transform:"translateY(-50%)"}
    :{bottom:"calc(100% + 6px)",left:"50%",transform:"translateX(-50%)"};
  return (
    <span style={{position:"relative",display:"inline-flex",...style}}
      onMouseEnter={()=>setOpen(true)} onMouseLeave={()=>setOpen(false)}
      onFocus={()=>setOpen(true)} onBlur={()=>setOpen(false)} {...rest}>
      {children}
      {open&&<span role="tooltip" style={{position:"absolute",zIndex:70,whiteSpace:"nowrap",
        padding:"5px 8px",background:"var(--teal-900)",color:"var(--fg-invert)",
        fontFamily:"var(--font-body)",fontSize:"var(--text-2xs)",borderRadius:"var(--radius-1)",
        boxShadow:"var(--shadow-pop)",...pos}}>{content}</span>}
    </span>
  );
}
